import React from 'react';
import PropTypes from "prop-types";

export default function CheckmarkPurpleSVG(props) {
  return (
    <svg
      width={props.styles.width} 
      height={props.styles.height} 
      version="1.1" 
      d="Layer_1" 
      xmlns="http://www.w3.org/2000/svg" 
      x="0px" 
      y="0px"
      viewBox="0 0 299.9 299.9">
      <g id="EddCVQ.tif">
        <g>
          <path 
            fill={props.styles.fill} 
            d="M299.9,150.1c0,83-67.6,150.1-150.3,149.8C66.6,299.6-0.3,232.2,0,149.6C0.3,66.7,67.7-0.1,150.1,0
			C233.1,0.1,300.1,67.6,299.9,150.1z M77.1,136c-7.8,7.8-15.5,15.5-23.3,23.2c0.1,0.1,0.3,0.3,0.5,0.5
			c21.4,21.5,42.9,42.9,64.4,64.4c0.8,0.8,1.4,0.7,2.2-0.1c41.5-41.5,83-83,124.6-124.6c0.3-0.3,0.5-0.6,0.7-0.8
			c-7.8-7.8-15.6-15.5-23.5-23.4c-34.3,34.3-68.7,68.6-103.1,103C105.4,164.2,91.3,150.1,77.1,136z"/>
        </g>
      </g>
    </svg>
  );
}

CheckmarkPurpleSVG.propTypes = {
  className: PropTypes.string,
  id: PropTypes.string,
  styles: PropTypes.shape({
    fill: PropTypes.string,
    height: PropTypes.string,
    width: PropTypes.string
  })
};
